<template>
  <el-table-column :label="label" :prop="prop" class-name="role-id" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'ロールID'
    },
    prop: {
      type: String,
      default: 'role_id'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.role-id {
      width: 10em;
    }
  }
}
</style>
